module.exports = __webpack_public_path__ + "img/assistant.a6c1bd80.svg";